<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .tc,.table{
    margin-top: 20px!important;
  }
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_13.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>16S/18S/ITS扩增子测序</h1>-->
<!--          <h2 class="mt10">16S / 18S / ITS amplicon sequencing（二代）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>16S/18S/ITS扩增子测序</h1>
      <h2 class="mt10">16S / 18S / ITS Amplicon Sequencing（二代）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">微生物多样性测序基于Illumina第二代高通量测序技术对16S rDNA/18S rDNA/ITS等序列进行测序，能同时对样品中的优势物种、稀有物种及一些未知的物种进行检测，获得样品中的微生物群落组成以及相对丰度。探讨微生物多样性对于研究微生物与环境的关系、环境治理和微生物资源的利用有着重要的理论和现实意义。 </p>
      <div class="c-title">产品优势</div>
      <ul class="strengths">
        <li>
          <h4>无需培养分离菌群</h4>
          <p>直接从环境样本中扩增核糖体rDNA高变区进行测序，解决了大部分菌株不可培养的难题。</p>
        </li>
        <li>
          <h4>客观还原菌群结构</h4>
          <p>专业、成熟、稳定的样本制备流程，严格控制PCR循环数，客观还原样品本身的菌群结构及丰度比例。</p>
        </li>
        <li>
          <h4>痕量菌检测</h4>
          <p>充分发挥高通量测序的大数据量优势，能检测出丰度低至万分之一的痕量菌。</p>
        </li>
      </ul>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <td style="width:300px;">参数</td>
          <td>微生物多样性测序</td>
        </tr>
        <tr>
          <td>技术平台</td>
          <td>Hiseq/Novaseq</td>
        </tr>
        <tr>
          <td>DNA质检</td>
          <td>双链DNA浓度 > 20 ng/μL，总量 > 200 ng</td>
        </tr>
        <tr>
          <td>测序策略</td>
          <td>PE250</td>
        </tr>
        <!-- <tr>
          <td>测序数据量</td>
          <td>5万tags，最低4万tags</td>
        </tr> -->
        <tr>
          <td>组装指标</td>
          <td>无</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>30个工作日</td>
        </tr>
      </table>
      <div class="c-title">技术路线</div>
      <div class="tc"><img src="@/assets/images/its_1.png"></div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/ITS.vue